/* 趙雲傳・第 1 章：博望・生獲夏侯蘭（約建安七年，202）
 * 史實：《先主傳》「使拒夏侯惇、于禁等於博望。久之，先主設伏兵，一旦自燒屯偽遁，惇等追之，為伏兵所破。」
 *       《李典傳》「備一旦燒屯去，惇率諸軍追擊之，典曰：『賊無故退，疑必有伏。南道狹窄，草木深，不可追也。』惇不聽，
 *       與于禁追之，典留守。惇等果入賊伏里，戰不利，典往救，備望見救至，乃散退。」
 *       《趙雲傳》注引《雲別傳》「先是，與夏侯惇戰於博望，生獲夏侯蘭。蘭是雲鄉里人，少小相知，雲白先主活之，薦蘭明於法律，以為軍正。」
 * 流程：1. 燒屯：到屯裡三處帳篷點火（曹軍的前鋒到之前燒完最好）。
 *       2. 偽遁：往南退過窄道，把追兵引進伏中；這時回頭打就露了底。
 *       3. 伏發：草叢裡的伏兵殺出。生獲夏侯蘭：打到他力竭（不會死），上前站定綁住；李典救到之前要綁到。
 *       4. 李典救至：和劉備一起散退到南邊。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero, rout, vanish } from '../kit.ts';
import { TUN, CAO, AMB, VALLEY_Y, SAFE } from '../maps/zhaoyun_bowang.ts';
import { MEN, WEI, SHU, npc } from './zhaoyun_kit.ts';

const LV = 8, ARRIVE = 55, RESCUE = 90;
const CAOB = { spec: WEI, name: '曹軍', hp: 400, maxHp: 400, atk: 18 };

export default {
  id: 'zhaoyun-1', map: 'zhaoyun_bowang', hero: 'zhaoyun',
  title: '第 1 章　博望', year: '約建安七年（202）',
  brief: {
    quote: [{ text: '先主設伏兵，一旦自燒屯偽遁，惇等追之，為伏兵所破。', src: '《三國志·蜀書·先主傳》' }, { text: '與夏侯惇戰於博望，生獲夏侯蘭。', src: '《趙雲傳》注引《雲別傳》' }],
    text: '劉備依附荊州的劉表，北上到葉縣。曹操派夏侯惇、于禁來拒，兩軍在博望相持很久。劉備決定燒掉自己的屯，假裝逃走。',
    goals: ['燒屯', '偽遁：把追兵引進南邊的窄道', '伏發：生獲夏侯蘭', '李典救至：散退'],
  },
  words: { ally: '劉備軍', foe: '曹軍' },
  stars: [
    { text: '曹軍趕到之前燒完三處營帳', ok: (m) => !m.vars.late },
    { text: '偽遁時沒有回頭交戰', ok: (m) => !m.vars.fought },
    { text: '伏兵陣亡不超過 3 人', ok: (m) => m.vars.amb && m.vars.amb.filter((u) => !u.alive).length <= 3 },
  ],
  fuel: (m, x, y) => SG.gd(x, y, TUN[0], TUN[1]) < 650 && SG.MAP.walkable(x, y, 0), // 火只在屯裡燒
  steps: [
    { // 1. 燒屯
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = TUN[0] - 150; me.y = TUN[1] + 220;
        V.lb = ally(w, 'liubei', TUN[0] + 160, TUN[1] + 240, LV); V.lb.hold = [V.lb.x, V.lb.y];
        // 三處帳篷：大帳和離它最遠的兩頂
        const tents = SG.MAP.trees.filter((t) => t.kind === 'tent'), chief = tents.find((t) => t.big) || tents[0];
        const far = tents.filter((t) => t !== chief).sort((a, b) => SG.gd(b.x, b.y, chief.x, chief.y) - SG.gd(a.x, a.y, chief.x, chief.y));
        V.tents = [chief, far[0], far.find((t) => SG.gd(t.x, t.y, far[0].x, far[0].y) > 300) || far[1]].map((t) => { const p = SG.MAP.nearestFree(t.x, t.y + 80); return { x: p[0], y: p[1], tx: t.x, ty: t.y, lit: false }; });
        V.tents.forEach((t, k) => m.mark('t' + k, t.x, t.y, '營帳', true));
        m.card('雲本屬公孫瓚，與先主相結。先主就袁紹，雲見於鄴，密遣雲合募得數百人，皆稱劉左將軍部曲，紹不能知。遂隨先主至荊州。', '《雲別傳》（裴注）');
        m.after(3, () => m.line('劉備', '夏侯惇、于禁和我們相持太久了。子龍，把屯燒了——我們假裝逃走。'));
        m.after(7, () => m.line('提示', '到三處營帳旁站定點火。曹軍的前鋒快到了。'));
        m.obj('burn', '燒屯', 3);
        V.t0 = w.t;
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.tents.forEach((t, k) => {
          if (t.lit) return;
          m.chanAt(me, 'burn' + k, t.x, t.y, 150, 2, '燒屯', () => {
            t.lit = true; m.unmark('t' + k);
            for (let i = -1; i <= 1; i++) m.fire(t.tx + i * 80, t.ty, { life: 25, dps: 30 });
            m.prog('burn', V.tents.filter((o) => o.lit).length);
          });
        });
        if (!V.late && w.t - V.t0 > ARRIVE) { V.late = true; m.line('斥候', '曹軍的前鋒看到這邊了！'); }
        return V.tents.every((t) => t.lit);
      },
    },
    { // 2. 偽遁
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('burn');
        m.card('先主設伏兵，一旦自燒屯偽遁。', '《先主傳》');
        V.lb.x = AMB[0][0]; V.lb.y = AMB[0][1]; V.lb.hold = AMB[0].slice(); // 劉備先去草叢裡設伏
        V.host = Array.from({ length: 12 }, (_, i) => m.foe('huangjin', CAO[0] - 300 + (i % 5) * 150, CAO[1] + 100 + Math.floor(i / 5) * 90, CAOB));
        V.lan = boss(w, MEN.xiahoulan, CAO[0] - 120, CAO[1] + 300, { name: '夏侯蘭', hp: 2200, atk: 28, armor: 5, ms: 245 });
        V.jin = boss(w, hero('yujin'), CAO[0] + 150, CAO[1] + 260, { name: '于禁', hp: 3200, atk: 34, armor: 7, ms: 235 });
        V.dun = boss(w, hero('xiahoudun'), CAO[0], CAO[1] + 150, { name: '夏侯惇', hp: 4200, atk: 38, armor: 8, ms: 235 });
        V.dian = npc(w, hero('lidian'), CAO[0] + 300, CAO[1], { name: '李典' });
        V.chase = V.host.concat([V.lan, V.jin, V.dun]);
        m.after(2, () => m.line('李典', '賊無故退，疑必有伏。南道狹窄，草木深，不可追也。'));
        m.after(5, () => m.line('夏侯惇', '劉備燒屯而逃，正好追擊！（惇不聽）'));
        m.after(8, () => m.line('提示', '往南退過窄道，把追兵引到草叢的伏兵中間。這時回頭交戰就露了底。'));
        m.mark('south', 4000, 3500, '窄道');
        m.obj('lure', '偽遁：往南退過窄道，把曹軍引進伏中');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        for (const u of V.chase) if (u.alive) u.home = [me.x, Math.max(CAO[1], me.y - 200)];
        if (!V.fought && V.chase.some((u) => u.alive && u.hp < u.maxHp - 1 && u.dmgBy && u.dmgBy[me.id])) { V.fought = true; m.line('夏侯惇', '回頭來打？哼，果然是虛張聲勢。'); }
        const deep = V.chase.filter((u) => u.alive && u.y > VALLEY_Y).length;
        return me.y > 3250 && deep >= 6;
      },
    },
    { // 3. 伏發：生獲夏侯蘭
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('lure'); m.unmark('south');
        m.big('伏兵四起！');
        m.card('惇等果入賊伏里，戰不利。', '《李典傳》');
        V.amb = [];
        for (const [x, y] of AMB) for (let i = 0; i < 6; i++) { const u = m.recruit(x + (i % 3 - 1) * 70, y + (i < 3 ? -30 : 40), '伏兵'); u.spec = SHU; u.hp = u.maxHp = 560; u.atk = 24; m.join(u, me); V.amb.push(u); }
        V.lb.hold = null;
        for (const u of V.chase) if (u.alive) { u.home = [u.x, u.y]; u.st.stun = Math.max(u.st.stun, 1.5); } // 伏兵突起，追兵一時大亂
        V.dun.home = [4000, 2300]; V.jin.home = [4100, 2500];
        m.after(2, () => m.line('趙雲', '夏侯蘭！是我，常山趙子龍！'));
        m.after(5, () => m.line('提示', '把夏侯蘭打到力竭（他不會死），再上前站定把他綁住。李典的救兵快到了。'));
        m.mark('lan', V.lan.x, V.lan.y, '夏侯蘭', false, V.lan);
        m.obj('lan', '生獲夏侯蘭');
        V.t2 = w.t;
      },
      tick(m, w) {
        const me = w.player, V = m.vars, lan = V.lan;
        if (!lan.yield && lan.hp < lan.maxHp * 0.35) {
          lan.yield = true; lan.untargetable = true; lan.target = null; lan.home = [lan.x, lan.y];
          if (me.input.target === lan) me.input.target = null;
          m.line('夏侯蘭', '子龍……是你。蘭力竭了，要殺便殺。');
          m.after(2, () => m.line('提示', '站到夏侯蘭身邊不動，把他綁住。'));
        }
        if (lan.yield && !V.got) {
          lan.st.stun = Math.max(lan.st.stun, 0.5); lan.target = null;
          m.chanAt(me, 'bind', lan.x, lan.y, 160, 2.5, '生獲', () => { V.got = true; m.line('趙雲', '綁了！帶回去見主公。'); }, { hurt: false });
        }
        const left = Math.max(0, Math.ceil(RESCUE - (w.t - V.t2)));
        m.get('lan').text = `生獲夏侯蘭（李典的救兵 ${left} 秒後到）`;
        if (!V.got && left <= 0) { m.lose('李典救至，夏侯蘭被救走'); return false; }
        return !!V.got;
      },
    },
    { // 4. 李典救至，散退
      enter(m, w) {
        const V = m.vars;
        m.done('lan'); m.unmark('lan');
        vanish(w, V.lan);
        rout(m, w, V.chase.filter((u) => u !== V.lan), CAO); // 戰不利：夏侯惇、于禁退走
        m.card('與夏侯惇戰於博望，生獲夏侯蘭。', '《雲別傳》（裴注）');
        m.after(4, () => {
          vanish(w, V.dian);
          V.dian2 = boss(w, hero('lidian'), CAO[0], CAO[1] + 600, { name: '李典', hp: 3600, atk: 44, armor: 7, ms: 240 });
          V.relief = Array.from({ length: 8 }, (_, i) => m.foe('huangjin', CAO[0] - 200 + (i % 4) * 130, CAO[1] + 700 + Math.floor(i / 4) * 90, CAOB));
          for (const u of V.relief.concat([V.dian2])) u.home = [4000, 2600];
          m.big('李典的救兵到了！');
          m.card('典往救，備望見救至，乃散退。', '《李典傳》');
          m.after(2, () => m.line('劉備', '曹軍的救兵到了，見好就收——散退！'));
          m.mark('safe', SAFE[0], SAFE[1], '南撤');
          m.obj('back', '散退：往南撤');
          V.go = true;
        });
      },
      tick(m, w) { return !!m.vars.go && m.near(w.player, SAFE[0], SAFE[1], 300); },
    },
    { // 5. 以為軍正
      enter(m, w) {
        const V = m.vars;
        m.done('back'); m.unmark('safe');
        rout(m, w, V.relief || [], CAO);
        m.card('蘭是雲鄉里人，少小相知，雲白先主活之，薦蘭明於法律，以為軍正。雲不用自近，其慎慮類如此。', '《雲別傳》（裴注）');
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('趙雲陣亡'); return; }
    if (V.lan && !V.lan.alive && !V.got) { m.lose('夏侯蘭被殺了。雲白先主活之——這一章要生擒他'); return; }
    if (V.lb && m.i <= 1) { V.lb.input.target = null; V.lb.input.engage = false; if (m.i === 1) V.lb.input.moveTo = null; } // 設伏：按兵不動
    if (V.lb && m.i === 0) allyTick(w, V.lb, null, 300);
    if (V.lb && m.i >= 2) allyTick(w, V.lb, w.player);
  },
};
